import {
  getFareFamilies
} from "./chunk-PMDLPOJM.mjs";

// src/hooks/wbk/flights/fares.ts
import { useQuery } from "@tanstack/react-query";
var useFareFamilies = (props) => {
  return useQuery({
    queryKey: ["getFareFamilies", props],
    queryFn: () => getFareFamilies(props),
    enabled: !!props.flightId && !!props.searchId
  });
};

export {
  useFareFamilies
};
//# sourceMappingURL=chunk-R4QGZAV3.mjs.map